@if (device.isMobile()) {
  <p-menu
    #menu
    [popup]="true"
    [model]="mobileOptions() || []"
    [appendTo]="appendTo()"
    [styleClass]="standardMenuStyleClass()"
  >
    <ng-template pTemplate="start">
      @if (startText() && !selectedParentOption()) {
        <div class="menu-header">
          <div class="status-box">
            <div class="status text-10 fw-700">{{ startText() }}</div>
          </div>
        </div>
      }
      @if (!selectedParentOption()) {
        <ng-container [ngTemplateOutlet]="startTemplate() ?? null"></ng-container>
      }
    </ng-template>

    <ng-template let-item pTemplate="item">
      <div
        class="option-item p-10-18 clickable {{ item.styleClass }}"
        [appTooltip]="item.tooltip || '' | translate"
        [tooltipPosition]="'top'"
        (click)="mobileOptionClicked(item, $event)"
      >
        @if (item.icon || item.customIcon || item.hasSubmenu) {
          <div class="icon-wrapper">
            @if (item.customIcon) {
              <app-dynamic-host
                [componentType]="item.customIcon"
                [componentInputs]="{ color: 'var(--icon-color)', height: 16, width: 16 }"
              ></app-dynamic-host>
            }
            @if (item.icon) {
              <i class="pi" [classList]="item.icon"></i>
            }
          </div>
        }

        <div
          class="text-wrapper text-14 {{ item.backButton ? 'fw-600' : 'fw-400' }}"
          [class.centered]="!item.icon && !item.customIcon && !item.hasSubmenu"
        >
          {{ item.label }}
        </div>

        @if (item.hasSubmenu) {
          <div class="icon-wrapper">
            <i class="pi pi-angle-right"></i>
          </div>
        }
      </div>
    </ng-template>
  </p-menu>
} @else {
  <p-tieredMenu
    #menu
    [popup]="true"
    [model]="tieredOptions() || []"
    [appendTo]="appendTo()"
    [styleClass]="tieredMenuStyleClass()"
    (appOnInit)="menu.dirty = true"
    (onShow)="menu.dirty = true"
  >
    <ng-template let-item pTemplate="item" let-hasSubmenu="hasSubmenu">
      @if (item.isStart) {
        <ng-container [ngTemplateOutlet]="startTemplate() ?? null"></ng-container>
      } @else {
        <div
          class="option-item p-10-18 clickable {{ item.styleClass }}"
          [appTooltip]="item.hint || '' | translate"
          [tooltipPosition]="'top'"
        >
          @if (item.icon || item.customIcon || hasSubmenu) {
            <div class="icon-wrapper">
              @if (item.customIcon) {
                <app-dynamic-host
                  [componentType]="item.customIcon"
                  [componentInputs]="{ color: 'var(--icon-color)', height: 16, width: 16 }"
                ></app-dynamic-host>
              }
              @if (item.icon) {
                <i class="pi" [classList]="item.icon"></i>
              }
            </div>
          }
          <div
            class="text-wrapper text-14 {{ item.backButton ? 'fw-600' : 'fw-400' }} "
            [class.centered]="!item.icon && !item.customIcon && !hasSubmenu"
          >
            {{ item.label }}
          </div>

          @if (hasSubmenu) {
            <div class="icon-wrapper">
              <i class="pi pi-angle-right"></i>
            </div>
          }
        </div>
      }
    </ng-template>
  </p-tieredMenu>
}
